/* eslint-disable global-require */
/**
 * Module dependencies
 */
const getActiveHelpChat = () => {
  try {
    const endpoint = '/help-chat';
    const browserRestClient = require('../utils/restclient-browser')();
    return browserRestClient.get(endpoint);
  } catch (e) {
    return {};
  }
};

module.exports = {
  getActiveHelpChat,
};

